const iconButton = {
  styleOverrides: {
    sizeSmall: {
      padding: 6,
    },
  },
};

export default iconButton;
